/**
 * Is a newer Airview Studio build live than the one running in this tab? A deploy replaces the
 * content-hashed bundle; a tab opened before it would otherwise keep lazy-loading old code that may
 * not understand new server data. We compare our own entry script with the one in a fresh index.html.
 */
const RELOAD_KEY = 'sightline.reloadedFor';

function myEntry(): string | null {
  const s = document.querySelector<HTMLScriptElement>('script[type="module"][src*="/assets/index-"]');
  return s ? new URL(s.src, location.href).pathname : null;
}

export async function newerBuildLive(): Promise<boolean> {
  const mine = myEntry();
  if (!mine || !import.meta.env.PROD) return false;
  try {
    const res = await fetch('/index.html', { cache: 'no-store' });
    if (!res.ok) return false;
    const html = await res.text();
    const live = /\/assets\/index-[\w-]+\.js/.exec(html)?.[0];
    return !!live && live !== mine;
  } catch {
    return false; // offline: keep running what we have
  }
}

/** Reload into the new build at most once per new build (no loops if something else is wrong). */
export async function reloadIfStale(): Promise<boolean> {
  if (!(await newerBuildLive())) return false;
  try {
    const html = await (await fetch('/index.html', { cache: 'no-store' })).text();
    const live = /\/assets\/index-[\w-]+\.js/.exec(html)?.[0] ?? '';
    if (sessionStorage.getItem(RELOAD_KEY) === live) return false;
    sessionStorage.setItem(RELOAD_KEY, live);
  } catch {
    /* storage blocked: still reload once */
  }
  location.reload();
  return true;
}
